import OperationType from 'service/constant/OperationType'
import ValueAddedType from 'service/constant/ValueAddedType'
export default [{
    dictKey: '',
    dictValue: '全部'
}, {
    dictKey: '1',
    dictValue: '快捷',
    flag: OperationType
}, {
    dictKey: '2',
    dictValue: '还款',
    flag: OperationType
}, {
    dictKey: '3',
    dictValue: '提现',
    flag:''
}, {
    dictKey: '4',
    dictValue: '增值业务',
    flag:ValueAddedType
}
];




// WEBPACK FOOTER //
// ./src/service/constant/BusinessType.js